
import { Check } from "lucide-react";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

interface AccessOptionProps {
  title: string;
  description: string;
  icon: React.ReactNode;
  bgClass: string;
  benefits: string[];
  isSelected: boolean;
  onClick: () => void;
}

export default function AccessOption({
  title,
  description,
  icon,
  bgClass,
  benefits,
  isSelected,
  onClick
}: AccessOptionProps) {
  return (
    <Card className={`relative overflow-hidden transition-all duration-200 ${isSelected ? "ring-2 ring-primary shadow-lg" : "hover:shadow-md"}`}>
      <div className={`absolute inset-0 bg-gradient-to-br ${bgClass} opacity-50 dark:opacity-30`} />
      <CardHeader className="relative">
        <div className="flex justify-between items-start">
          <div>
            <CardTitle className="flex items-center gap-2">
              {icon}
              {title}
            </CardTitle>
            <CardDescription>{description}</CardDescription>
          </div>
          {isSelected && (
            <div className="bg-primary rounded-full p-1">
              <Check className="h-4 w-4 text-white" />
            </div>
          )}
        </div>
      </CardHeader>
      <CardContent className="relative">
        <ul className="space-y-2 text-sm">
          {benefits.map((benefit, index) => (
            <li key={index} className="flex items-center gap-2">
              <Check className="h-4 w-4 text-green-500" />
              <span>{benefit}</span>
            </li>
          ))}
        </ul>
      </CardContent>
      <CardFooter className="relative">
        <Button 
          variant={isSelected ? "secondary" : "outline"} 
          className="w-full"
          onClick={onClick}
        >
          {isSelected ? "Selecionado" : "Selecionar"}
        </Button>
      </CardFooter>
    </Card>
  );
}
